/**
 * Phone chat (GistUp) DTOs: REST plus the `S2C.PhoneChatNew` push (92 A10).
 * One area group chat per area (Q-27); DMs between two characters.
 */
import { z } from 'zod';
import { Recipient, Uuid } from './common';
export const CHAT_BODY_MAX = 1000;
export const CHAT_PAGE_MAX = 100;
export const ChannelIdParamSchema = z.object({ id: Uuid });
/** `GET /v1/chat/channels/{id}/messages?before=&limit=`: newest first, `seq < before`. */
export const ChatMessagesQuerySchema = z.object({
    before: z.coerce.number().int().min(1).optional(),
    limit: z.coerce.number().int().min(1).max(CHAT_PAGE_MAX).default(50),
});
/** `POST /v1/chat/channels/{id}/messages`. A repeated `clientMsgId` returns the stored message. */
export const PostChatMessageRequestSchema = z.object({
    clientMsgId: z.string().min(1).max(64),
    body: z.string().trim().min(1).max(CHAT_BODY_MAX),
});
/** `POST /v1/chat/dm {to}`: opens (or returns) the DM channel with that character. */
export const CreateDmRequestSchema = z.object({
    /** Phone number or character id. */
    to: Recipient,
});
